module.exports = __webpack_public_path__ + "img/ck-ranking-award-rule.daa6d910.png";